import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: ${({ theme }) => theme.space["space-4"]};
  border-bottom: 1px solid ${({ theme }) => theme.colors.blue["100"]};
`;
